import React, { useState } from 'react';
import './ExportActionsSection.css';
import ExcelExportModal from './ExcelExportModal';
import SendEmailWizard from './SendEmailWizard';

interface ExportActionsSectionProps {
    projectId: string;
    projectName: string;
    token: string;
}

const ExportActionsSection: React.FC<ExportActionsSectionProps> = ({ projectId, projectName, token }) => {
    const [showExcelModal, setShowExcelModal] = useState(false);
    const [showEmailWizard, setShowEmailWizard] = useState(false);

    const handleSendMails = () => {
        setShowEmailWizard(true);
    };

    const handleExportExcel = () => {
        setShowExcelModal(true);
    };

    return (
        <>
            <div className="export-actions-section">
                <div className="export-actions-header">
                    <h4>Export & Kommunikation</h4>
                </div>
                <div className="export-actions-buttons">
                    <button
                        className="export-action-btn send-mails-btn"
                        onClick={handleSendMails}
                    >
                        📧 E-Mails versenden
                    </button>
                    <button
                        className="export-action-btn export-excel-btn"
                        onClick={handleExportExcel}
                    >
                        📊 Excel exportieren
                    </button>
                </div>
            </div>

            {showExcelModal && (
                <ExcelExportModal
                    projectId={projectId}
                    token={token}
                    onClose={() => setShowExcelModal(false)}
                />
            )}

            {showEmailWizard && (
                <SendEmailWizard
                    projectId={Number(projectId)}
                    projectName={projectName}
                    token={token}
                    onClose={() => setShowEmailWizard(false)}
                />
            )}
        </>
    );
};

export default ExportActionsSection;
